import { useState } from 'react';
import { historyService } from 'services';
import { ConsignmentDetails, FormOption } from 'types';
import { Heading, Print, Select, Text } from 'components';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from 'helpers/local-storage';
import {
  FontSize,
  FontWeight,
  LABEL_SIZE,
  LocalStorageKeys,
  TEST_IDS,
  historyTypes,
} from 'commons';
import { ShippingLabel } from './components';
import * as S from './styles';

interface Props {
  consignment: ConsignmentDetails;
}

export function PrintLabel({ consignment }: Props) {
  const storedValue = getLocalStorageItem(
    LocalStorageKeys.LabelSize,
    LABEL_SIZE.small
  );
  const [labelSize, setLabelSize] = useState<string>(storedValue);

  const options: FormOption[] = [
    { label: 'Etiqueta 10x4', value: LABEL_SIZE.small },
    { label: 'Etiqueta 10x10', value: LABEL_SIZE.large },
  ];

  function changeSize(e: any) {
    const { target } = e;

    if (target) {
      const newValue = target.value;

      setLocalStorageItem(LocalStorageKeys.LabelSize, newValue);

      setLabelSize(newValue);
    }
  }

  function postShippingLabelHistory() {
    const store = consignment.reservedPOS.name;

    historyService.post({
      type: historyTypes.labelPrint,
      consignmentCode: consignment.code,
      store,
    });
  }

  return (
    <S.Main>
      <S.Section $limitedSize>
        <S.TextWrapper>
          <Heading size={FontSize.font16} weight={FontWeight.bold}>
            Imprimir etiqueta
          </Heading>

          <Text size={FontSize.font12}>
            Selecione abaixo o tamanho da etiqueta a ser impressa para
            identificação do pedido
          </Text>
        </S.TextWrapper>

        <Select.Wrapper
          data-testid={TEST_IDS.PRINT_LABEL_SIZE_SELECT}
          name="size"
          onChange={changeSize}
          options={options}
          initialSelected={options.find((option) => option.value === labelSize)}
        >
          <Select.Input placeholder="Selecione..." />

          <Select.StatusArrow />
        </Select.Wrapper>

        <Print
          data-testid={TEST_IDS.PRINT_LABEL_BUTTON}
          onClick={postShippingLabelHistory}
          Template={
            <ShippingLabel
              consignmentDetails={consignment}
              isLarge={labelSize === LABEL_SIZE.large}
            />
          }
        >
          Imprimir etiqueta
        </Print>
      </S.Section>

      <S.Section $alignEnd>
        <ShippingLabel
          consignmentDetails={consignment}
          isLarge={labelSize === LABEL_SIZE.large}
        />
      </S.Section>
    </S.Main>
  );
}
